// External Dependencies
import React from 'react';
import { GetBrandedLogo, GetBrandedLogoAltText } from '../../services/BrandingService';
import FaSignOut from 'react-icons/lib/fa/sign-out';
import HelpButton from '../Teacher/HelpButton'

// Internal Dependencies
import { getUserData, endUserSession } from '../../services/API';
import { userTypes } from '../../constants/constants';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";
import { withTranslation } from 'react-i18next';

class GlobalNav extends React.Component {
  constructor (props){
    super(props);

    this.menuOptions = [
      {value: 'SCORING', label: "review_activity", route: '/teacher/gradebook/activities', identifier: 'gradebook'},
      {value: 'REPORTS', label: "reports", route: '/teacher/reports', identifier: 'reports'},
    ];

    // if admin, add the admin page
    if(getUserData().userType == userTypes.SCHOOL_ADMIN || getUserData().userType == userTypes.DISTRICT_ADMIN || getUserData().reportingRole) {
      this.menuOptions.unshift({value: 'ADMIN', label: 'Admin', route: '/admin', identifier: 'admin'});
    }

    this.state = {
      logo: GetBrandedLogo(),
      logoAltText: GetBrandedLogoAltText()
    }

    this.goHome = this.goHome.bind(this);
    this.logOut = this.logOut.bind(this);
  }

  getButtonClick(menuOption){
    return () => {this.props.history.push(menuOption.route)};
  }

  goHome(){
    this.props.history.push("/teacher/gradebook/activities");
  }

  logOut(){
    endUserSession();
  }

  // determine whether a menu item is active by comparing to the current URL
  // TODO: implement a better solution
  isActive(menuOption){
    return this.props.location.pathname.includes(menuOption.identifier);
  }

  render() {
    return (
      <div className="globalNav">
        <div className="navButtonContainer" role="navigation">
          <span className="home" {...doNotUseAccessibleStaticElementInteractions({onClick: this.goHome})}>
            <img src={this.state.logo} alt={this.state.logoAltText} />
          </span>
          <div className="rightButtons">
            {this.menuOptions.map((opt) => {
              let className = "navButton" + (this.isActive(opt) ? " active" : "") + ` ${opt?.label}`;
              return (
                <span key={opt.value} className={className} {...doNotUseAccessibleStaticElementInteractions({onClick: this.getButtonClick(opt)})}> {this.props.t(opt.label)} </span>);
            })}
            <HelpButton />
            <span className="navButton logoutButton" {...doNotUseAccessibleStaticElementInteractions({onClick: this.logOut})}><FaSignOut className="logoutIcon" size="22" /> {this.props.t("log_out")}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("reports")(GlobalNav);